// Self-contained data for the Historia Events PH events concept website.
export const BUSINESS = {
  "slug": "historia-events-ph-concept",
  "media": null,
  "name": "Historia Events PH",
  "shortName": "Historia",
  "kind": "planner",
  "layout": "glamour",
  "location": "Iloilo City",
  "address": "Lopez Jaena St., San Isidro / Jaro, Iloilo City 5000, Philippines",
  "eyebrow": "Since 2018 · Iloilo",
  "headline": "Lavish weddings. Exquisite celebrations. Stress-free planning.",
  "intro": "Dramatic event planning for weddings, debuts, private celebrations and corporate occasions in Iloilo.",
  "lead": "Mack LV",
  "leadRole": "Coordinator / lead associated with Historia",
  "story": "Historia’s own public material says the team has been creating well-planned, meaningful events since 2018. Mack LV is publicly associated with the business as a coordinator and lead.",
  "services": [
    "Weddings",
    "Debuts",
    "Private celebrations",
    "Birthdays",
    "Corporate events",
    "Planning and coordination",
    "Event styling"
  ],
  "process": [
    "Define the character of the celebration",
    "Develop the planning and styling direction",
    "Coordinate the people and production",
    "Deliver a composed guest experience"
  ],
  "proof": [
    "Publicly active since 2018",
    "Wedding, debut and corporate range",
    "Current local partnership activity"
  ],
  "reviewSnapshot": "Public rating last checked in August 2026: 5.0/5 from 5 reviews. Individual review text was not available.",
  "reviews": [],
  "contact": {
    "phone": "+63 945 263 7145",
    "phoneHref": "+639452637145",
    "facebook": "https://www.facebook.com/HistoriaEventPlanners/"
  },
  "sources": [
    "https://www.facebook.com/HistoriaEventPlanners/",
    "https://www.facebook.com/historiaeventsph/",
    "https://www.facebook.com/historiaeventsph/photos/since-2018-historia-events-ph-has-been-dedicated-to-creating-well-planned-meanin/122109238658807893/",
    "https://iloilodirectory.com/categories/events/"
  ]
};
